// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__XCV7F","navContainer":"Nav_navContainer__a7I-5","logo":"Nav_logo__QR8zV","menu":"Nav_menu__mueCQ","menuItem":"Nav_menuItem__7bb9Q"};